import React, { Context, createContext, Dispatch, FC, ReactNode, useEffect, useRef, useState } from "react";

// TODO Proper Filter Context... Current implementation is an example.

export interface ExampleFilterContextValue {
    selectedGroup: string;
    selectedOptions: string[];
    filterOptions: string[];
}

export interface FilterContextHolder {
    exampleFilterContext: ExampleFilterContextValue;
    setExampleFilterContext: Dispatch<ExampleFilterContextValue>;
}

interface FilterContextValue {
    exampleFilterContext: ExampleFilterContextValue;
}

export const FilterContext: Context<FilterContextHolder> =
    createContext({
        exampleFilterContext: {
            selectedGroup: "",
            selectedOptions: [],
            filterOptions: [],
        },
        setExampleFilterContext: (newFilterContext: ExampleFilterContextValue) => {
            return newFilterContext;
        },
    } as FilterContextHolder);

interface Props {
    children?: ReactNode;
}

export const FilterContextProvider: FC<Props> = ({
    children,
}) => {

    const localStorageKey = "FilterContext";

    const filterContext =
        useRef<FilterContextValue>(
            JSON.parse(localStorage.getItem(localStorageKey) || "false")
            || {
                exampleFilterContext: {
                    selectedGroup: "",
                    selectedOptions: [],
                    filterOptions: [],
                },
            } as FilterContextValue
        );

    const [ exampleFilterContext, setExampleFilterContext ] =
        useState<ExampleFilterContextValue>(filterContext.current?.exampleFilterContext);

    useEffect(() => {
        if (exampleFilterContext) {
            console.log("Updating ExampleFilterContext...");
            filterContext.current = {
                ...filterContext.current,
                exampleFilterContext: { ...exampleFilterContext },
            };
            localStorage.setItem(
                localStorageKey,
                JSON.stringify(filterContext.current)
            );
            console.log("Updated ExampleFilterContext...");
        }
    }, [ exampleFilterContext ]);


    return (
        <>
            <FilterContext
                value={{
                    exampleFilterContext,
                    setExampleFilterContext,
                }}
            >
                {children}
            </FilterContext>
        </>
    );
};